<template>
  <div>
    <top-nav :routelist="routeList"></top-nav>
    <router-view></router-view>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  watch: {
    '$route': 'setFirstRoute'
  },
  computed: {
    ...mapGetters(['hasPermission']),
    routeList() {
      return [
        {
          name: '直观',
          route: 'trouble_zg',
          right: true,
        },
        {
          name: 'CMA',
          route: 'trouble_cma',
          right: true,
        }
      ]
    }
  },
  methods: {
    setFirstRoute() {
      if (this.$route.name === 'trouble') {
        for (let item of this.routeList) {
          if (item.right) {
            this.$router.push({name: item.route})
            return
          }
        }
      }
    }
  },
  created() {
    this.setFirstRoute()
  }
}
</script>
